var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsPlatformIconIos = function SvgNewcsPlatformIconIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_platform_icon_ios_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h18v18H0z",
    "data-name": "\\u77E9\\u5F62 363"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_platform_icon_ios_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#807997",
    d: "M13.694 9.5A3.585 3.585 0 0 0 16 12.738a8.7 8.7 0 0 1-1.191 2.276c-.717.974-1.459 1.945-2.631 1.964-1.152.021-1.522-.635-2.838-.635s-1.728.616-2.817.656c-1.13.04-1.991-1.052-2.714-2.024C2.331 12.988 1.2 9.36 2.72 6.912a4.26 4.26 0 0 1 3.556-2.006c1.111-.019 2.159.7 2.837.7s1.953-.859 3.292-.733a4.12 4.12 0 0 1 3.144 1.584A3.61 3.61 0 0 0 13.694 9.5M8.978 4.687a3.22 3.22 0 0 1 .912-2.476A3.96 3.96 0 0 1 12.423 1a3.37 3.37 0 0 1-.9 2.554 3.28 3.28 0 0 1-2.55 1.133",
    "data-name": "\\u8DEF\\u5F84 477"
  }))));
};
export default SvgNewcsPlatformIconIos;